import { createBuilderModule } from '../../../builder';
import { SectionName, withTracking } from '../../../observability/tracking';
import { COLOR_KEYS } from '../../../constants';
import { SplitColorAccordionSection } from './SplitColorAccordionSection';
import { DEFAULT_VALUES } from './fixtures';

export default createBuilderModule(
  withTracking(SplitColorAccordionSection, {
    as: 'section',
    sectionName: SectionName.SplitColorAccordionSection,
  }),
  {
    name: 'SplitColorAccordionSection',
    image: 'https://cdn.zappy.app/4d90d4065a92673542dc544b85272782.png',
    inputs: [
      {
        name: 'heading',
        type: 'richText',
        required: true,
        defaultValue: DEFAULT_VALUES.heading,
      },
      {
        name: 'ctaText',
        type: 'string',
        required: false,
        defaultValue: DEFAULT_VALUES.ctaText,
      },
      {
        name: 'ctaUrl',
        type: 'string',
        required: false,
        defaultValue: DEFAULT_VALUES.ctaUrl,
      },
      {
        name: 'accordionItems',
        type: 'list',
        subFields: [
          {
            name: 'heading',
            type: 'string',
            required: true,
          },
          {
            name: 'body',
            type: 'richText',
            required: true,
          },
          {
            name: 'imageUrl',
            type: 'cloudinaryImage',
            required: false,
          },
          {
            name: 'animationDataUrl',
            friendlyName: 'Animation URL',
            type: 'cloudinaryMediaLibrary',
            helperText: 'URL for either a Lottie JSON or an MP4 video',
            required: false,
          },
          {
            name: 'animationAssetsUrl',
            type: 'string',
            required: false,
            helperText:
              'Path to the folder that contains image assets for Lottie animations',
          },
          {
            name: 'animationShouldLoop',
            type: 'boolean',
            required: false,
          },
          {
            name: 'animationSpeed',
            type: 'number',
          },
          {
            name: 'mediaAltText',
            type: 'string',
            required: true,
          },
        ],
        defaultValue: DEFAULT_VALUES.accordionItems,
      },
      {
        name: 'backgroundColor',
        type: 'string',
        enum: [
          COLOR_KEYS.bolt,
          COLOR_KEYS.moss,
          COLOR_KEYS.neutral800,
          COLOR_KEYS.night,
          COLOR_KEYS.peach,
          COLOR_KEYS.zapier,
          COLOR_KEYS.neutral100,
          COLOR_KEYS.lavender,
          COLOR_KEYS.sky,
          COLOR_KEYS.earth,
        ],
        required: true,
        defaultValue: DEFAULT_VALUES.backgroundColor,
      },
    ],
  },
);
